import {InfoIcon} from '../../icons'
import {colors} from '../../utils/colors'
import {useSelector} from 'react-redux'
import classNames from 'classnames'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const InfoBox = ({value, type}) => {
    const text = useNamespaceTranslations('notifications')
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const channelInfoTexts = {
        email: text.code_description_email.replace(':value', value || text.entered),
        sms: text.code_description_sms.replace(':value', value || text.entered),
        phone: text.code_description_sms.replace(':value', value || text.entered),
        telegram: text.code_description_telegram.replace(':value', value || text.entered)
    }

    return (
        <div className={classNames('form-info-box', {
            dark: isDarkMode
        })}>
            <span className="info-icon">
                <InfoIcon color={colors.colorBlue}/>
            </span>
            <div className="info-box-text">
                <span
                    dangerouslySetInnerHTML={{__html: channelInfoTexts[type]}}/>
            </div>
        </div>
    )
}

export default InfoBox
